import Image from "next/image";
import React from "react";
import AgentImage from "../../public/images/advertise/agent.png";

const Appointement = () => {
  return (
    <div className="my-40">
      <div className="flex gap-16">
        <div className="flex flex-col w-1/2 gap-10 mt-8">
          <div className="text-lg font-bold">Be Better Than Before</div>
          <div className="flex flex-col gap-2 text-5xl font-extrabold">
            <span>Make an</span>
            <span>appointment with</span>
            <span>our advertising</span>
            <span>department.</span>
          </div>

          <div className="font-semibold leading-loose">
            We look forward to speaking with you about the pricing, the process,
            and the dashboard. It should only take us 30 minutes, but we are
            happy to schedule longer if you would like more time. We {"can't "}
            wait to meet you!
          </div>
        </div>
        <div>
          <Image src={AgentImage.src} width={609} height={570} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Appointement;
